<!-- 供应商订单管理 -->
<template>
    <div :style="{ '--color': themeColor, '--lightColor': lightThemeColor }" class="container">
        <header class="header">
            <div class="header-div">
                <p @click="isShow = !isShow">收起搜索板</p>
                <i :class="isShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" @click="isShow = !isShow"></i>
            </div>
        </header>
        <el-collapse-transition>
            <div v-show="isShow">
                <div class="title">
                    <div class="selectBox">
                        <div class="left">
                            <div class="leftLine1">
                                <p class="p1">分润类型：</p>
                                <el-button :class="init.q.type == '0' ? 'active' : ''" class="btns1"
                                           plain
                                           size="small" style="margin-right: 0.06rem" @click="handlerSelectClick2('0')">自己的子订单
                                </el-button>
                                <el-button :class="init.q.type == '1' ? 'active' : ''" class="btns1"
                                           plain
                                           size="small" style="margin-right: 0.06rem" @click="handlerSelectClick2(1)">客户的子订单
                                </el-button>
                            </div>
                            <div class="leftLine1">
                                <p class="p1">产品类型：</p>
                                <el-button :class="init.q.state == null ? 'active' : ''" class="btns1"
                                           plain
                                           size="small" style="margin-right: 0.06rem" @click="handlerSelectClick(null)">全部
                                </el-button>
                                <div v-for="(item) in resourceType" :key="item.typeName">
                                    <div v-if="item.name != '交' && item.name != '服'"
                                         :class="init.q.state === item.code ? 'active' : ''" class="btns"
                                         @click="handlerSelectClick(item.code)">
                                        {{ item.name }}
                                    </div>
                                </div>
                            </div>
                            <div class="leftLine1">
                                <p class="p1">库存类型：</p>
                                <div class="line"></div>
                                <el-button :class="current1 === 'all' ? 'active' : ''" class="btns1"
                                           plain
                                           size="small" style="margin-right: 0.06rem" @click="handlerSelectClick1('all')">全部
                                </el-button>
                                <div v-for="(item, index) in btnsList" :key="index">
                                    <el-button :class="current1 === item ? 'active' : ''" class="btns1"
                                               size="small" style="margin-right: 0.06rem"
                                               @click="handlerSelectClick1(item)">
                                        {{ item }}
                                    </el-button>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="rightBox1">
                                <div class="stateClBox">
                                    <div v-for="item in statusList" :key="item.name" class="stateCl">
                                        <p class="p2">{{ item.num }}</p>
                                        <p class="p3">{{ item.name }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="rightBox2">
                                <p class="p1">符合条件共：</p>
                                <div v-for="item in userList" :key="item.name" class="userCl">
                                    <p class="p2">
                                        {{ item.num }} <span>{{ item.currency }}</span>
                                    </p>
                                    <p class="p3">{{ item.name }}</p>
                                </div>
                                <div class="userCl">
                                    <p class="p4">清空</p>
                                    <p class="p4">筛选条件</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="selectBox1">
                        <p style="color: #333333;font-size: 0.14rem; font-family: SourceHanSansSC-bold;font-weight: bold;">
                            订单状态：
                        </p>
                        <div style="flex: 1; display: flex; justify-content: space-between">
                            <div v-for="(item, keys) in stepList" :key="keys" class="stepBox">
                                <p class="p1">{{ keys }}</p>
                                <el-checkbox v-for="(item1, index) in item" :key="index" :label="item1.name"
                                             class="checkbox" size="small" style="margin-bottom: 0.1rem"
                                             @change="selectStateChange(item1)"></el-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="selectBox2">
                        <div class="right">
                            <div class="rightLine1">
                                <p class="p1">查询关键词</p>
                                <el-select v-model="value" placeholder="请选择" size="small"
                                           style="margin-right: 0.1rem; width: 1.5rem">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                                <el-input v-model="init.q.childrenIds[0]" clearable
                                          placeholder="订单编号"
                                          size="small" style="width: 1.5rem; margin-right: 0.1rem"></el-input>
                                <el-input v-model="init.q.planId" clearable
                                          placeholder="团号" size="small"
                                          style="width: 1.1rem; margin-right: 0.1rem"></el-input>
                                <el-input clearable placeholder="询单号" size="small"
                                          style="width: 1.1rem; margin-right: 0.1rem"></el-input>
                                <el-input v-model="init.q.resourceNameKey" clearable
                                          placeholder="资源名称"
                                          size="small" style="width: 1.2rem; margin-right: 0.1rem"></el-input>
                                <!-- <el-input size="small" style="width: 1.1rem; margin-right: 0.1rem" clearable
                                  placeholder="用户账号"></el-input> -->
                                <el-input v-model="init.q.createName" placeholder="下单人"
                                          size="small"
                                          style="width: 1rem; margin-right: 0.1rem"></el-input>
                                <el-input clearable placeholder="分润用户账号" size="small"
                                          style="width: 1.5rem; margin-right: 0.1rem"></el-input>
                                <el-input clearable placeholder="用户公司名称/账号" size="small"
                                          style="width: 1.8rem; margin-right: 0.1rem"></el-input>
                                <el-input clearable placeholder="国家/城市" size="small"
                                          style="width: 1.5rem; margin-right: 0.1rem"></el-input>
                                <el-input clearable placeholder="库存商品" size="small"
                                          style="width: 1.1rem; margin-right: 0.1rem"></el-input>
                                <!-- <el-input size="small" style="width: 1.2rem; margin-right: 0.1rem" clearable
                                  placeholder="库存供应商"></el-input> -->
                            </div>
                            <div class="rightLine2">
                                <p class="p1">时间</p>
                                <el-radio-group v-model="init.q.timeType" size="small"
                                                style="margin-right: 0.05rem"
                                                @change="init.page = 1,orderSelectedData = [],orderList()">
                                    <el-radio :label="1">下单日期</el-radio>
                                    <el-radio :label="2">付款日期</el-radio>
                                    <el-radio :label="3">使用日期</el-radio>
                                </el-radio-group>
                                <el-date-picker v-model="dateArr" end-placeholder="结束日期" range-separator="至"
                                                size="small"
                                                start-placeholder="开始日期" style="margin-right: 0.1rem" type="daterange"
                                                value-format="yyyy-MM-dd"
                                                @change="handlerSelectDate">
                                </el-date-picker>
                                <p class="p1">金额</p>
                                <el-radio-group size="small" style="margin-right: 0.1rem">
                                    <el-radio :label="3">
                                        <span style="margin-right: 0.05rem">大于等于</span>
                                        <el-input size="small" style="width: 0.7rem; margin-right: 0.05rem"></el-input>
                                        <span>¥</span>
                                    </el-radio>
                                    <el-radio :label="9">
                                        <span style="margin-right: 0.05rem">小于等于</span>
                                        <el-input size="small" style="width: 0.7rem; margin-right: 0.05rem"></el-input>
                                        <span>¥</span>
                                    </el-radio>
                                    <el-radio :label="6">
                                        <el-input size="small" style="width: 0.7rem; margin-right: 0.05rem"></el-input>
                                        <span>¥</span>
                                        <span style="margin-right: 0.06rem">至</span>
                                        <el-input size="small" style="width: 0.7rem; margin-right: 0.05rem"></el-input>
                                        <span style="margin-right: 0.05rem">¥</span>
                                    </el-radio>
                                </el-radio-group>
                                <el-checkbox :checked="Boolean(init.q.includesToBeConfirmed)" style="margin-right: 0.05rem;"
                                             @change="resChange">待选的资源
                                </el-checkbox>
                                <el-button
                                    plain
                                    size="small" type="primary" @click="init.page = 1, init.q.childrenIds = init.q.childrenIds.filter(n => n),orderSelectedData = [], orderList()">搜索
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-collapse-transition>
        <div class="tablerCl">
            <div class="topLine">
                <p class="p1">数据列表
                    <el-tag effect="dark" style="margin-left: 0.1rem;" type="danger">
                        勾选商品总计人民币：{{ checkTheAmount }}¥
                    </el-tag>
                </p>
                <div class="btnBox">
                    <el-button plain size="small" style="margin-right: 0.1rem" type="primary">导出</el-button>
                </div>
            </div>
        </div>
        <staticTable :dataType="init.q.type" :loading="loading" :tableData="listDatas"
                     @openModifyPopup="openModifyPopup"
                     @openPay="openPay" @openStockpopup="openStockpopup" @orderSelect="orderSelect"
                     @updateList="updateList">
        </staticTable>
        <Pagination :currentPage="init.page" :pageSizes="pageSizes" :parentPageSize="10" :totalNumber="AllpagesNum"
                    @loadTable='loadTable'></Pagination>
        <stockPopup ref="stockPopup" @openPay="openPay" @updateList="updateList"></stockPopup>
        <stockPay ref="stockPay" :dataMap="payData.dataMap"
                  :orderChildrenIds="payData.orderChildrenIds" :orderMainId="payData.orderMainId"
                  :payMoney="payData.payMoney" @payUpload="$refs.PaymentPricePopup.close()"></stockPay>
        <PaymentPricePopup ref="PaymentPricePopup" @payOrder="payOrder"></PaymentPricePopup>
    </div>
</template>
<script>
import {mapState} from "vuex";
import {resourceType, days} from "@/assets/utils/unit";
import staticTable from "./child/staticTable.vue";
import OrderApi from '@/components/Api/order.js'
import Pagination from '@/components/Pagination.vue'
import {OrderMinxin} from './sonOrderMinxin'
import {sortByCreateTime} from '@/assets/utils/unit'
import stockPopup from "./child/stockPopup.vue";
import stockPay from "./child/stockPay.vue";
import PaymentPricePopup from "./child/PaymentPricePopup.vue";

export default {
    components: {
        staticTable,
        OrderApi,
        Pagination,
        stockPopup,
        stockPay,
        PaymentPricePopup,
    },
    mixins: [OrderMinxin],
    data() {
        return {
            days,
            loading: true,
            isShow: true,
            AllpagesNum: 0,
            orderSelectedData: [],
            pageSizes: [10, 30, 60, 100],
            dateArr: [],
            payData: {},//打开支付弹框需要的参数
            init: {
                "page": 1,
                "q": {
                    childrenIds: [],
                    orderMainId: null,
                    resourceId: null,
                    planId: '',
                    resourceNameKey: null,
                    type: 0,
                    state: null,
                    statusList: [],
                    createName: '',//下单人 下单日期  2 付款日期  3 使用日期
                    timeType: 1,
                    startTime: '',
                    endTime: '',
                    includesToBeConfirmed: 0,
                },
                "size": 10
            },
            listDatas: [],
            value: "",
            options: [
                {
                    value: "选项1",
                    label: "PC端订单",
                },
                {
                    value: "选项2",
                    label: "小程序",
                },
            ],
            resourceType,
            current1: "all",
            current2: "自己的子订单",
            btnsList: ["FIT库存", "预算库存", "专属库存"],
            btnsList1: [
                "只有部分库存申请拆单",
                "申请关闭订单",
                "催促客户付款",
                "提醒客户使用",
                "提醒已消费客户评价",
                "设置取消费用",
                "导出",
                "订单操作",
            ],
            userList: [
                {
                    name: "订单",
                    num: 400,
                    currency: "",
                },
                {
                    name: "客户",
                    num: 400,
                    currency: "",
                },
                {
                    name: "订单总额",
                    num: 400,
                    currency: "¥",
                },
            ],
            statusList: [
                {
                    state: "",
                    name: "待支付",
                    num: 0,
                    icon: "ze-certificate",
                },
                {
                    state: "",
                    name: "确认中",
                    num: 4,
                    icon: "ze-certificate",
                },
                {
                    state: "",
                    name: "已确认",
                    num: 4,
                    icon: null,
                },
                {
                    state: "",
                    name: "待出行",
                    num: 4,
                    icon: null,
                },
                {
                    state: "",
                    name: "待处理",
                    num: 4,
                    icon: null,
                },
                {
                    state: "",
                    name: "待点评",
                    num: 4,
                    icon: null,
                },
            ],
            stepList: {
                Step1: [{
                    name: "待支付",
                    state: "1A1A1A"
                }],
                Step2: [
                    {
                        name: "待确认",
                        state: "2A2A2A"
                    }
                ],
                Step3: [
                    {
                        name: "待出行",
                        state: "3A3A3A"
                    }
                ],
                Step4: [
                    {
                        name: "已完成",
                        state: "5A5A5A"
                    }
                ],
                Step5: [

                ],
                Step6: [],
                // Step2: [
                //   "待抢单",
                //   "已拒单",
                //   "已抢待确认",
                //   "订单失效",
                //   "抢单超时",
                //   "已被他人抢走",
                // ],
                // Step3: ["已接单（待发V）"],
                // Step4: ["待出行"],
                // Step5: ["待点评"],
                // Step6: ["交易完成"],
            },
        };
    },
    computed: {
        ...mapState(["themeColor"]),
        ...mapState(["lightThemeColor"]),
        ...mapState(["nearThemeColor"]),
        checkTheAmount() {
            let price = 0
            this.orderSelectedData.forEach(n => {
                price += Number(this.totalPrice(n.orderListDetailResultList))
            })
            return price.toFixed(2)
        }
    },
    watch: {},
    methods: {
        payOrder(obj) {
            this.payData = obj
            this.$refs.stockPay.init()
        },
        //打开支付弹框
        openPay(ids) {
            this.$refs.PaymentPricePopup.open(ids)
        },
        openStockpopup(row, orderChildrenId) {
            this.$refs.stockPopup.open(row, orderChildrenId)
        },
        resChange(val) {
            this.init.q.includesToBeConfirmed = Number(val)
            this.init.page = 1
            this.orderList()
        },
        handlerSelectDate(val) {
            this.orderSelectedData = []
            this.init.q.startTime = val ? val[0] : null
            this.init.q.endTime = val ? val[1] : null
            this.init.page = 1
            this.orderList()
        },
        totalPrice(arr) {
            let price = 0
            arr.forEach(n => {
                price += n.price * n.number * n.rate * (this.days(n.startTime, n.endTime) + 1)
            });
            return price.toFixed(2)
        },
        orderSelect(e) {
            this.orderSelectedData = e
        },
        selectStateChange(val) {
            this.orderSelectedData = []
            if (this.init.q.statusList.findIndex(n => n === val.state) === -1) {
                this.init.q.statusList.push(val.state)
            } else {
                this.init.q.statusList = this.init.q.statusList.filter(n => n !== val.state)
            }
            this.search()
        },
        // 搜索
        search() {
            this.init.q.page = 1;
            this.init.q.pageSize = 10;
            this.orderSelectedData = []
            this.orderList();
        },
        //更新数据
        updateList() {
            this.orderList()
        },
        //自己的订单
        ownOrder() {
            new OrderApi('order').platOrderList(this.init).then(res => {
                if (res.status == 200) {
                    this.listDatas = res.data.records
                    this.listDatas.forEach((item) => {
                        if (item.truncationResult) {
                            item.truncationResult.opLogResults = sortByCreateTime(item.truncationResult.opLogResults)
                        }
                    })
                    this.AllpagesNum = res.data.total
                    this.loading = false
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth' // 可以选择'smooth'或'auto'
                    });
                } else {
                    this.$message.error({message: res.statusText})
                }
            })
        },
        //客户的订单
        customerSOrder() {
            let obj = {
                "page": this.init.page,
                "q": {
                    state: this.init.q.state,
                    statusList: this.init.q.statusList,
                    resourceNameKey: this.init.q.resourceNameKey
                },
                "size": this.init.size
            }
            new OrderApi('order').platCustomerOrderList(obj).then(res => {
                if (res.status == 200) {
                    this.listDatas = res.data.records
                    this.listDatas.forEach((item) => {
                        if (item.truncationResult.opLogResults) {
                            item.truncationResult.opLogResults = sortByCreateTime(item.truncationResult.opLogResults)
                        }
                    })
                    this.AllpagesNum = res.data.total
                    this.loading = false
                } else {
                    this.$message.error({message: res.statusText})
                }
            })
        },
        // 子订单列表
        orderList() {
            this.loading = true
            if (this.init.q.type == 0) {
                this.ownOrder()
            } else {
                this.customerSOrder()
            }
        },
        loadTable(page, size) {
            this.init.size = size
            this.init.page = page
            this.loading = true
            this.orderList()
        },
        //资源按钮选择
        handlerSelectClick(item) {
            this.init.q.state = item;
            this.orderList()
        },
        //库存类型选择
        handlerSelectClick1(item) {
            this.current1 = item;
        },
        handlerSelectClick2(type) {
            this.init.q.state = null
            this.$store.state.orderFlowDirection = type
            this.init.q.type = type
            this.init.q.page = 1
            this.orderList()
        },
        //打开调整订单金额弹框
        openModifyPopup() {
            this.$refs.modifyTable.dialogVisible = true;
        },
    },
    created() {
    },
    beforeDestroy() {
        this.$Bus.$off("PAY_SUCCESS");
    },
    mounted() {
        this.$Bus.$on("PAY_SUCCESS", (data) => {
            this.unpdateData(data)
        });
        this.orderList()
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-radio {
    margin-right: 0.1rem;
}

.container {
    background-color: #fff;

    .active {
        background-color: var(--color) !important;
        color: #fff !important;
    }

    .header {
        display: flex;
        align-items: center;

        .header-div {
            flex: 1;
            height: 0.4rem;
            line-height: 0.4rem;
            background-color: rgba(255, 255, 255, 1);
            color: rgba(16, 16, 16, 1);
            font-size: 0.14rem;
            font-family: Roboto;
            border: 1px solid rgba(187, 187, 187, 1);
            display: flex;
            align-items: center;
            justify-content: center;

            p,
            i {
                margin-right: 0.12rem;
                cursor: pointer;
            }

            &:nth-child(1) {
                border-right: none;
            }
        }
    }

    .title {
        padding: 0.15rem;
        margin-bottom: 0.12rem;

        .selectBox {
            display: flex;
            align-items: center;

            .left {
                margin-right: 0.12rem;

                .leftLine1 {
                    display: flex;
                    align-items: center;
                    margin-bottom: 0.2rem;

                    .btns1 {
                        background-color: #f7e1d3;
                        color: var(--color);
                        border: none;
                    }

                    .p1 {
                        color: #333333;
                        font-size: 0.14rem;
                        font-family: SourceHanSansSC-bold;
                        font-weight: bold;
                    }

                    .btns {
                        width: 0.25rem;
                        height: 0.25rem;
                        line-height: 0.25rem;
                        background-color: #f7e1d3;
                        color: var(--color);
                        font-size: 0.14rem;
                        text-align: center;
                        font-family: Roboto;
                        border-radius: 50%;
                        margin-right: 0.14rem;
                        cursor: pointer;
                    }
                }
            }

            .right {
                display: flex;
                align-items: center;
                flex: 1;

                .rightBox1 {
                    padding: 0 0.12rem;
                    width: 50%;
                    height: 0.7rem;
                    background-color: var(--color);
                    text-align: center;
                    border: 3px solid var(--color);
                    display: flex;
                    align-items: center;

                    .stateClBox {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .stateCl {
                            .p2 {
                                color: rgba(255, 255, 255, 1);
                                font-size: 0.22rem;
                                font-weight: bold;
                                font-family: SourceHanSansSC-bold;
                            }

                            .p3 {
                                color: rgba(255, 255, 255, 1);
                                font-size: 0.12rem;
                                font-family: SourceHanSansSC-regular;
                            }
                        }
                    }
                }

                .rightBox2 {
                    padding: 0 0.12rem;
                    width: 50%;
                    height: 0.7rem;
                    border: 3px solid var(--color);
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .p1 {
                        color: rgba(16, 16, 16, 1);
                        font-size: 0.12rem;
                        font-family: SourceHanSansSC-regular;
                    }

                    .userCl {
                        margin-right: 0.3rem;
                        display: flex;
                        align-items: center;
                        flex-direction: column;

                        .p2 {
                            color: var(--color);
                            font-size: 0.18rem;
                            font-weight: bold;
                            font-family: SourceHanSansSC-bold;

                            span {
                                color: #000;
                            }
                        }

                        .p3 {
                            color: rgba(16, 16, 16, 1);
                            font-size: 0.12rem;
                            text-align: left;
                            font-family: SourceHanSansSC-regular;
                        }

                        .p4 {
                            color: #316b39;
                            font-size: 0.14rem;
                            font-family: SourceHanSansSC-regular;
                        }
                    }
                }
            }
        }

        .selectBox1 {
            display: flex;
            margin-bottom: 0.24rem;

            .stepBox {
                .p1 {
                    color: var(--color);
                    font-size: 0.16rem;
                    font-family: Roboto-bold;
                    font-weight: bold;
                    margin-bottom: 0.12rem;
                }

                display: flex;
                flex-direction: column;
            }
        }

        .selectBox2 {
            display: flex;
            align-items: center;
            background-color: #f0f0f0;
            padding: 0.2rem;

            .right {
                .rightLine1 {
                    display: flex;
                    align-items: center;
                    margin-bottom: 0.2rem;

                    .p1 {
                        font-weight: bold;
                        color: rgb(51, 51, 51);
                        margin-right: 0.15rem;
                    }
                }

                .rightLine2 {
                    display: flex;
                    align-items: center;

                    .p1 {
                        color: #000;
                        font-size: 0.14rem;
                        font-family: SourceHanSansSC-bold;
                        font-weight: bold;
                        margin-right: 0.1rem;
                    }
                }
            }
        }
    }

    .tablerCl {
        .topLine {
            height: 0.6rem;
            line-height: 0.6rem;
            background-color: rgba(255, 255, 255, 1);
            padding: 0 0.24rem;
            display: flex;
            align-items: center;

            .btnBox {
                display: flex;
                align-items: center;
                margin-left: auto;
            }

            .p1 {
                color: rgba(16, 16, 16, 1);
                font-size: 0.14rem;
                font-family: SourceHanSansSC-regular;
                font-weight: bold;
            }
        }
    }
}
</style>
